const contactMessagePath = 'contact.';
const contactButtonMsgPath = contactMessagePath + 'buttons.';

const contactTrans = {
    TITLE : contactMessagePath + 'pageTitle',

    EXPERIENCE_CAPTION : contactMessagePath + "experienceContent",
    FEEDBACK_DESCRIPTION : contactMessagePath + "feedbackDescription",
    SHARE_YOUR_FEEDBACK : contactMessagePath + "shareYourFeedback",
    SHARE_FEEDBACK_DESCRIPTION : contactMessagePath + "shareFeedbackDescription",
    OTHER_CONNECT : contactMessagePath + "otherConnect",
    NEED_HELP : contactMessagePath + "needHelp",
    HELP_DESCRIPTION : contactMessagePath + "helpDescription",
    PREFER_MAIL : contactMessagePath + "preferMail",
    REACH_MAIL : contactMessagePath + "reachMail",
    RESPOND_DESCRIPTION : contactMessagePath + "respond",

    TAKE_SURVEY_LABEL : contactButtonMsgPath + "takeSurvey",
    OPEN_FAQS_LABEL : contactButtonMsgPath + "openFaq",
}

export default contactTrans